"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PageController = /*#__PURE__*/function () {
  function PageController() {
    _classCallCheck(this, PageController);

    this.body = document.getElementsByTagName("body")[0];
    this.footer = document.getElementById("global-footer");
    this.content = document.getElementById("content");
    this.template = $('body').data('template');
    this.flashMessage = new FlashMessage();
    this.arrayUtils = new ArrayUtils();
    this.dateUtils = new DateUtils();
    this.numberUtils = new NumberUtils();
    this.stringUtils = new StringUtils();
    AOS.init({
      once: true
    });
    this.initSliders();

    var _this = this;

    var showedNumberCounters = false;
    $(window).scroll(function (event) {
      if (showedNumberCounters === false) {
        if (_this.isScrolledIntoView($(".numbers-calc"))) {
          showedNumberCounters = true;

          _this.initNumberCounters();
        }
      }
    });

    if (_this.isScrolledIntoView($(".numbers-calc"))) {
      showedNumberCounters = true;

      _this.initNumberCounters();
    }
  }

  _createClass(PageController, [{
    key: "initNumberCounters",
    value: function initNumberCounters() {
      $('[data-number-counter="true"]').each(function (index) {
        var counter = new NumberCounter($(this));
      });
    }
  }, {
    key: "isScrolledIntoView",
    value: function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();
      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      var sliderElements = document.querySelectorAll('.default-slider, .box-slider');
      sliderElements.forEach(function (element) {
        if (element.classList.contains('box-slider')) {
          new BoxSlider(element);
        }
      });
    }
  }]);

  return PageController;
}();